export class GetAllCountries {
  static readonly type = '[Countries] Get';
}
